import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AppStatusIncidents.module.scss';
import AppStatusTextPreview from './AppStatusTextPreview';
import ImageViewerModal from './ImageViewerModal';

type AppStatusDetailPreviewProps = {
  imageAltTranslationKey: string;
  imageUrl: string | null;
  value: string;
};

const AppStatusDetailPreview: FC<AppStatusDetailPreviewProps> = ({
  imageAltTranslationKey,
  imageUrl,
  value,
}) => {
  const { t } = useTranslation();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const previewLabel = t('appStatus.form.previewImage');

  return (
    <div className={styles['detail-preview']}>
      {value && <AppStatusTextPreview value={value} />}
      {imageUrl && (
        <>
          <button
            type="button"
            onClick={() => setIsPreviewOpen(true)}
            aria-label={previewLabel}
            title={previewLabel}
          >
            <i className="pi pi-image" aria-hidden="true" />
          </button>
          <ImageViewerModal
            alt={t(imageAltTranslationKey)}
            isOpen={isPreviewOpen}
            onClose={() => setIsPreviewOpen(false)}
            url={imageUrl}
          />
        </>
      )}
    </div>
  );
};

export default AppStatusDetailPreview;
